(function () {
  var STYLE_ID = 'yuimart-shopify-forms-style';
  var SAKURA_MARK = 'https://yuimart.com/cdn/shop/files/yui-sakura-knot-favicon-transparent_512x512.png?v=1788491270';

  var css = `
    :host {
      --yuimart-forms-green: #587742;
      --yuimart-forms-green-dark: #486638;
      --yuimart-forms-ink: #42434d;
      --yuimart-forms-paper: #fffaf0;
      --yuimart-forms-soft: #ecf2e1;
      font-family: inherit !important;
    }

    *, *::before, *::after {
      box-sizing: border-box;
      letter-spacing: 0 !important;
    }

    [class*="form-wrapper"],
    [class*="form-container"],
    [class*="popup"],
    [class*="modal"] {
      font-family: inherit !important;
    }

    [class*="form-container"],
    [class*="form-wrapper"] > div:not([class*="overlay"]):not([class*="teaser"]),
    [role="dialog"] {
      position: relative;
      isolation: isolate;
      overflow: hidden;
      border: 1px solid rgba(88, 119, 66, 0.18) !important;
      border-radius: 8px !important;
      background-color: var(--yuimart-forms-paper) !important;
      background-image:
        linear-gradient(118deg, rgba(255, 255, 255, 0.94) 0%, rgba(255, 250, 240, 0.9) 55%, rgba(236, 242, 225, 0.82) 100%),
        repeating-linear-gradient(135deg, rgba(143, 124, 88, 0.055) 0, rgba(143, 124, 88, 0.055) 1px, transparent 1px, transparent 9px) !important;
      box-shadow: 0 18px 44px rgba(72, 82, 56, 0.16), 0 2px 0 rgba(255, 255, 255, 0.72) inset !important;
    }

    [class*="form-container"]::before,
    [class*="form-wrapper"] > div:not([class*="overlay"]):not([class*="teaser"])::before,
    [role="dialog"]::before {
      content: "";
      position: absolute;
      right: 24px;
      top: 28px;
      z-index: -1;
      width: min(34vw, 174px);
      aspect-ratio: 1;
      opacity: 0.075;
      background: url('${SAKURA_MARK}') center / contain no-repeat;
      transform: rotate(-8deg);
      pointer-events: none;
    }

    [class*="form-container"]::after,
    [class*="form-wrapper"] > div:not([class*="overlay"]):not([class*="teaser"])::after,
    [role="dialog"]::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: -1;
      height: 44px;
      background:
        radial-gradient(86% 52px at 50% 100%, rgba(88, 119, 66, 0.15) 0, rgba(88, 119, 66, 0.11) 42%, transparent 43%),
        linear-gradient(0deg, rgba(244, 238, 221, 0.86), transparent);
      pointer-events: none;
    }

    h1, h2, h3,
    [class*="heading"],
    [class*="title"] {
      color: #4f5d3a !important;
      font-weight: 700 !important;
      line-height: 1.2 !important;
    }

    p,
    label,
    [class*="description"],
    [class*="body"],
    [class*="content"] {
      color: #5b5043 !important;
      line-height: 1.55 !important;
    }

    input[type="email"],
    input[type="text"],
    input[type="tel"],
    input:not([type]),
    select,
    textarea {
      min-height: 48px !important;
      border: 1px solid rgba(88, 119, 66, 0.24) !important;
      border-radius: 6px !important;
      background: rgba(255, 255, 255, 0.86) !important;
      color: var(--yuimart-forms-ink) !important;
      box-shadow: 0 8px 18px rgba(79, 93, 58, 0.07) !important;
    }

    input::placeholder,
    textarea::placeholder {
      color: rgba(66, 67, 77, 0.55) !important;
    }

    input:focus,
    select:focus,
    textarea:focus {
      border-color: rgba(88, 119, 66, 0.58) !important;
      outline: 2px solid rgba(88, 119, 66, 0.2) !important;
      outline-offset: 2px !important;
    }

    button,
    [type="submit"],
    [class*="submit"] {
      min-height: 46px !important;
      border: 0 !important;
      border-radius: 6px !important;
      background: var(--yuimart-forms-green) !important;
      color: #ffffff !important;
      font-weight: 700 !important;
      box-shadow: 0 8px 18px rgba(88, 119, 66, 0.18) !important;
    }

    button:hover,
    button:focus-visible,
    [type="submit"]:hover,
    [type="submit"]:focus-visible,
    [class*="submit"]:hover,
    [class*="submit"]:focus-visible {
      background: var(--yuimart-forms-green-dark) !important;
    }

    [class*="close"] {
      color: #4f5d3a !important;
    }

    [class*="teaser"] {
      border: 1px solid rgba(88, 119, 66, 0.2) !important;
      border-radius: 8px !important;
      background: rgba(255, 250, 240, 0.94) !important;
      color: #4f5d3a !important;
      box-shadow: 0 12px 30px rgba(72, 82, 56, 0.14) !important;
    }

    @media (max-width: 640px) {
      [class*="form-container"],
      [class*="form-wrapper"] > div:not([class*="overlay"]):not([class*="teaser"]),
      [role="dialog"] {
        border-radius: 8px !important;
      }

      [class*="form-container"]::before,
      [class*="form-wrapper"] > div:not([class*="overlay"]):not([class*="teaser"])::before,
      [role="dialog"]::before {
        right: -18px;
        top: 18px;
        width: 132px;
      }
    }
  `;

  function formatWelcomeHeading(root) {
    if (!root || !root.querySelectorAll) return false;

    var headings = root.querySelectorAll('h1, h2, h3, [role="heading"]');
    for (var i = 0; i < headings.length; i += 1) {
      var heading = headings[i];
      if (heading.dataset.ymWelcomeFormatted === 'true') return true;

      var text = (heading.textContent || '').replace(/\s+/g, ' ').trim();
      var match = text.match(/^(Welcome\s+to\s+Yui\s+Mart!)\s*(?:Enjioy|Enjoy)\s*(5%.*)$/i);
      if (!match) continue;

      var discountLine = document.createElement('span');
      discountLine.style.display = 'block';
      discountLine.style.marginTop = '0.18em';
      discountLine.textContent = 'Enjoy ' + match[2].trim();

      heading.replaceChildren(document.createTextNode(match[1]), discountLine);
      heading.dataset.ymWelcomeFormatted = 'true';
      return true;
    }

    return false;
  }

  function styleEmbed(embed) {
    if (!embed || !embed.shadowRoot) return;

    if (!embed.shadowRoot.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = css;
      embed.shadowRoot.appendChild(style);
    }

    [0, 250, 750, 1500, 3000].forEach(function (delay) {
      window.setTimeout(function () {
        formatWelcomeHeading(embed.shadowRoot);
      }, delay);
    });
  }

  function scan() {
    document.querySelectorAll('shopify-forms-embed').forEach(styleEmbed);
  }

  scan();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  }

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
